import { createContext } from 'react';

export default createContext({
  unfollowedBrands: [],
  setUnfollowedBrands: () => {},
});
